import { render } from "./AddProperties.vue?vue&type=template&id=9182a9f0&scoped=true&ts=true"
import script from "./AddProperties.vue?vue&type=script&lang=ts"
export * from "./AddProperties.vue?vue&type=script&lang=ts"

import "./AddProperties.vue?vue&type=style&index=0&id=9182a9f0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9182a9f0"]])

export default __exports__